export default __webpack_public_path__ + "static/media/purchaseWithScones.e4e122ed.jpg";